module.exports = __webpack_public_path__ + "static/media/cd2-icon-pending.ba4f8874.svg";